module.exports = __webpack_public_path__ + "static/img/phone-chathide.682f948e.png";